export default function proxiedMessages(messages) {
    return messages;
}

//# sourceMappingURL=proxiedMessages.js.map